export const CAIP_NAMESPACE = 'cosmos';
